import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useScan } from "../contexts/ScanContext";

const ProtectedRoute = ({ children }) => {
  const { user, authChecking } = useScan();
  const location = useLocation();

  if (authChecking) {
    return <div>Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

export default ProtectedRoute;
